/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const generateBrandingDataSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	url: z.string().url(),
})

export type GenerateBrandingDataSchema = z.infer<typeof generateBrandingDataSchema>
